var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z",
    fill: "#0E1F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5C23.4558 2.5 29.5 8.54416 29.5 16C29.5 23.4558 23.4558 29.5 16 29.5C8.54416 29.5 2.5 23.4558 2.5 16C2.5 8.54416 8.54416 2.5 16 2.5Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.30322C13.608 9.30322 11.6666 11.4239 11.6666 14.0368C11.6666 16.5993 13.504 18.682 15.9422 18.7578C15.9768 18.7578 16.0231 18.7578 16.0462 18.7578C16.0693 18.7578 16.104 18.7578 16.1271 18.7578C16.1386 18.7578 16.1502 18.7578 16.1502 18.7578C18.4844 18.6694 20.3217 16.5993 20.3333 14.0368C20.3333 11.4239 18.392 9.30322 16 9.30322Z",
    fill: "#0E1F33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0607 25.4083C22.6819 27.6309 19.5014 28.9997 16.0001 28.9997C12.4988 28.9997 9.3182 27.6309 6.93945 25.4083C7.26018 24.1751 8.12882 23.0502 9.39838 22.1829C13.0467 19.7164 18.9802 19.7164 22.6017 22.1829C23.8847 23.0502 24.7399 24.1751 25.0607 25.4083Z",
    fill: "#0E1F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircleWhite);
export default __webpack_public_path__ + "static/media/profile-circle-white.149cbeeb97126d0d5a9b706834d0b527.svg";
export { ForwardRef as ReactComponent };